import * as React from "react";

const MONTHS = [
  "Հունվար",
  "Փետրվար",
  "Մարտ",
  "Ապրիլ",
  "Մայիս",
  "Հունիս",
  "Հուլիս",
  "Օգոստոս",
  "Սեպտեմբեր",
  "Հոկտեմբեր",
  "Նոյեմբեր",
  "Դեկտեմբեր",
];

export default function EndDate({ deadline }) {
  if (!deadline) return null;
  const date = new Date(deadline);
  if (isNaN(date.getTime())) return null;

  const year = date.getFullYear();
  ///
  const day = date.getDate();
  const index = date.getMonth();

  return (
    <div
      style={{ fontFamily: "Noto Sans Armenian" }}
      className="flex flex-row items-center gap-2 p-1 md:p-1.5 pr-3 md:pr-4 rounded-xl md:rounded-2xl bg-[#f0f4ff] dark:bg-slate-900 border border-[#0033FF]/10 dark:border-white/5 shrink-0"
    >
      <div className="flex shrink-0 items-center justify-center rounded-lg md:rounded-xl w-7 h-7 md:w-9 md:h-9 text-white text-xs md:text-sm font-bold shadow-sm">
        {day}
      </div>
      <div className="flex flex-col justify-center leading-tight">
        <span className="text-[11px] md:text-xs font-bold text-slate-900 dark:text-white">
          {MONTHS[index]}
        </span>
        <span className="text-[9px] md:text-[10px] font-medium text-slate-500 dark:text-slate-400">
          {year}
        </span>
      </div>
    </div>
  );
}
